import { useEffect, useRef, useState } from "react";

export default function ContactSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} id="contact" className="py-20 md:py-28 bg-warm-50">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
        <div
          className={`transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <p className="text-stone-500 text-xs tracking-[0.3em] mb-4">
            CONTACT
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-stone-900 mb-4">
            ご予約・お問い合わせ
          </h2>
          <p className="text-stone-500 text-sm md:text-base mb-10 md:mb-12">
            お電話にてご予約・お問い合わせを承っております。
            <br className="hidden md:block" />
            お気軽にお電話ください。
          </p>
        </div>

        <div
          className={`transition-all duration-700 delay-150 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <a
            href="tel:0557-95-1813"
            className="inline-flex items-center gap-4 px-10 py-5 bg-warm-700 text-white text-lg md:text-xl rounded-full hover:bg-warm-800 transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line text-2xl" />
            0557-95-1813
          </a>
          <p className="mt-4 text-stone-400 text-sm">
            年中無休でお受けしております
          </p>
        </div>
      </div>
    </section>
  );
}